import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants/apiconstants/domainUrl'
import { checkAuthorization } from '../../../helpers'
import { message } from 'antd'

export const getFooterdetailsapi = createAsyncThunk('getFooterDetails',
    async (_, { dispatch, getState }) => {

        const { userToken }= checkAuthorization()
        dispatch(gettingFooterDetail())
        var myHeaders = new Headers()
        myHeaders.append("Authorization", userToken)
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };
        fetch(domainUrl + `/getFooterDetails`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(getFooterResponse(result?.data))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(getFooterResponse())
                message.error(error) 
            })
    }
)

const GetFooterDetailsSlice = createSlice({
    name: 'FooterdetailsApi',
    initialState: {
        footerData:null,
        loadingFooter:false,
    },
    reducers: {
        gettingFooterDetail: (state, action) => {
            state.loadingFooter = true
            state.footerData = null
        },
        getFooterResponse: (state, action) => {
            state.footerData = action.payload
            state.loadingFooter = false
        }
    },
})

export const { gettingFooterDetail, getFooterResponse } = GetFooterDetailsSlice.actions
export default GetFooterDetailsSlice.reducer